import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import LightDiagnosticResource, {
  LightDiagnosticResource as LightDiagnosticResourceResourceClass
} from '@/modules/lightdiagnostic/resources/LightDiagnosticResource';
import { LightDiagnosticCalculatePlanForm } from '@/modules/lightdiagnostic/models/LightDiagnosticCalculatePlanForm';
import { LightDiagnosticSubmission } from '@/modules/lightdiagnostic/models/LightDiagnosticSubmission';

export class LightDiagnosticService extends BaseService {
  resource: LightDiagnosticResourceResourceClass;

  constructor() {
    super();
    this.resource = LightDiagnosticResource;
  }

  async calculateBillingPlan(params: Params = {}): Promise<LightDiagnosticCalculatePlanForm> {
    return LightDiagnosticCalculatePlanForm.mapModel(
      await this.resource.calculateBillingPlan(params)
    );
  }

  async syncSubmissionToHubspot(params: Params = {}): Promise<Partial<LightDiagnosticSubmission>> {
    return LightDiagnosticSubmission.mapModel(await this.resource.syncSubmissionToHubspot(params));
  }
}

export default new LightDiagnosticService();
